import {Injectable} from '@angular/core';
import {CurrencyApiService, CurrencyRate} from '@npck/af-frontend-api';
import {DATE_SERVER_FORMAT} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {Observable, shareReplay} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CurrencyRatesHolderService {
    private ratesByDate: Record<string, Observable<CurrencyRate[]>> = {};

    constructor(private currencyApiService: CurrencyApiService) {
    }

    getRates(date: string = dayjs().format(DATE_SERVER_FORMAT)): Observable<CurrencyRate[]> {
        if (!this.ratesByDate[date]) {
            this.ratesByDate[date] = this.currencyApiService.getCurrencyRates(date).pipe(shareReplay(1));
        }
        return this.ratesByDate[date];
    }
}
